export default [
    {
        "id": "login",
        "html": require('./login/html').default,
        "css": require('./login/css').default,
        "scss": require('./login/scss').default
    }
]